import { ACTION_CODE, EVENT_CODE } from '@constants'

import { ActionRow, Dictionary, GETShareColumn, Table } from '../types'

export const getAvailableActionEvents = (
  bindingValuesActionEvents?: Dictionary[],
  actionTable?: Table<ActionRow>,
  currentRow?: GETShareColumn | ActionRow | null,
  watchActionCode?: ACTION_CODE | null
) => {
  if (!bindingValuesActionEvents) {
    return []
  }

  const filteredActionEvents = filterActionEvents(
    bindingValuesActionEvents,
    actionTable,
    watchActionCode
  )

  if (currentRow) {
    if (
      currentRow.eventCode === EVENT_CODE.ON_COLUMN_RIGHT_CLICK ||
      currentRow.eventCode === EVENT_CODE.ON_ROW_CREATE
    ) {
      return filteredActionEvents
    }

    const currentAction = bindingValuesActionEvents.find(
      actionEvent => actionEvent.code === currentRow.eventCode
    )

    if (currentAction) {
      const isUsed = filteredActionEvents.some(event => event.code === currentAction.code)

      if (!isUsed) {
        filteredActionEvents.push(currentAction)
      }
    }
  }

  return filteredActionEvents
}

const filterActionEvents = (
  bindingValuesActionEvents: Dictionary[],
  actionTable?: Table<ActionRow>,
  watchActionCode?: ACTION_CODE | null
): Dictionary[] => {
  let filteredActionEvents: Dictionary[]

  if (watchActionCode === ACTION_CODE.DELETE_OBJECT) {
    filteredActionEvents = bindingValuesActionEvents.filter(
      actionEvent =>
        actionEvent.code === EVENT_CODE.ON_ROW_DELETE_BUTTON_CLICK &&
        !actionTable?.rows.find(event => event.eventCode === actionEvent.code)
    )
  } else {
    filteredActionEvents = bindingValuesActionEvents.filter(
      actionEvent =>
        actionEvent.code !== EVENT_CODE.ON_ROW_DELETE_BUTTON_CLICK &&
        !actionTable?.rows.find(
          event =>
            event.eventCode === actionEvent.code &&
            event.eventCode !== EVENT_CODE.ON_COLUMN_RIGHT_CLICK &&
            event.eventCode !== EVENT_CODE.ON_ROW_CREATE
        )
    )
  }

  const hasOpenFormModelWithCreate = actionTable?.rows.some(
    row =>
      row.eventCode === EVENT_CODE.ON_ROW_CREATE && row.actionCode === ACTION_CODE.OPEN_FORM_MODEL
  )

  const hasOpenNewLineWithCreate = actionTable?.rows.some(
    row =>
      row.eventCode === EVENT_CODE.ON_ROW_CREATE && row.actionCode === ACTION_CODE.OPEN_NEW_LINE
  )

  switch (watchActionCode) {
    case ACTION_CODE.OPEN_FORM_MODEL:
      return filteredActionEvents.filter(
        actionEvent =>
          actionEvent.code !== EVENT_CODE.ON_ROW_ADDITIONAL_BUTTON_CLICK &&
          !(actionEvent.code === EVENT_CODE.ON_ROW_CREATE && hasOpenFormModelWithCreate)
      )
    case ACTION_CODE.OPEN_ANOTHER_FORM_MODEL:
      return filteredActionEvents.filter(
        actionEvent => actionEvent.code === EVENT_CODE.ON_ROW_ADDITIONAL_BUTTON_CLICK
      )
    case ACTION_CODE.DOWNLOAD_FILE:
      return filteredActionEvents.filter(
        actionEvent => actionEvent.code === EVENT_CODE.ON_ROW_DOWNLOAD_BUTTON_CLICK
      )
    case ACTION_CODE.PREVIEW_FILE:
      return filteredActionEvents.filter(
        actionEvent => actionEvent.code === EVENT_CODE.ON_ROW_PREVIEW_BUTTON_CLICK
      )
    case ACTION_CODE.OPEN_NEW_LINE:
      return filteredActionEvents.filter(
        actionEvent => actionEvent.code === EVENT_CODE.ON_ROW_CREATE && !hasOpenNewLineWithCreate
      )
    case ACTION_CODE.PRINT_FORM_VOU:
      return filteredActionEvents.filter(
        actionEvent => actionEvent.code === EVENT_CODE.ON_BUTTON_CLICK
      )
    case ACTION_CODE.MODIFY_DATA:
      return filteredActionEvents.filter(
        actionEvent => actionEvent.code === EVENT_CODE.AFTER_LOAD_DATA
      )
    case ACTION_CODE.SET_DATA:
      return filteredActionEvents.filter(
        actionEvent => actionEvent.code === EVENT_CODE.ON_VARIABLE_CHANGE
      )
    case ACTION_CODE.CHANGE_VARIABLE_VALUE:
      return filteredActionEvents.filter(
        actionEvent =>
          actionEvent.code === EVENT_CODE.AFTER_LOAD_DATA ||
          actionEvent.code === EVENT_CODE.ON_ROW_SELECTION ||
          actionEvent.code === EVENT_CODE.ON_DRAG_START
      )
    default:
      return filteredActionEvents
  }
}
